// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { createClientLogger } from "@azure/logger";

/** The `@azure/logger` instance used by this package. */
export const logger = createClientLogger("communication-common");
